/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Is_Still_Generating_TInputs */

const en_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipt is still generating. Try again in a minute.`)
};

const es_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El recibo aún se está generando. Intenta de nuevo en un minuto.`)
};

const fr_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le reçu est toujours en cours de génération. Réessayez dans une minute.`)
};

const de_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quittung wird noch generiert. Versuche es in einer Minute noch einmal.`)
};

const ja_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領収書はまだ作成中です。1分後にもう一度お試しください。`)
};

const zh_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收据仍在生成中。请稍后再试。`)
};

const ar_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يزال جاري إنشاء الإيصال. حاول مرة أخرى بعد دقيقة.`)
};

const id_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanda terima masih dibuat. Coba lagi dalam semenit.`)
};

const it_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ricevuta è ancora in fase di generazione. Riprova tra un minuto.`)
};

const ru_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чек все еще формируется. Попробуйте снова через минуту.`)
};

const pt_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O recibo ainda está sendo gerado. Tente novamente em um minuto.`)
};

const ko_receipt_is_still_generating_t = /** @type {(inputs: Receipt_Is_Still_Generating_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영수증이 아직 생성 중입니다. 1분 후에 다시 시도해 주세요.`)
};

/**
* | output |
* | --- |
* | "Receipt is still generating. Try again in a minute." |
*
* @param {Receipt_Is_Still_Generating_TInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const receipt_is_still_generating_t = /** @type {((inputs?: Receipt_Is_Still_Generating_TInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Is_Still_Generating_TInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_receipt_is_still_generating_t(inputs)
	if (locale === "es") return es_receipt_is_still_generating_t(inputs)
	if (locale === "fr") return fr_receipt_is_still_generating_t(inputs)
	if (locale === "de") return de_receipt_is_still_generating_t(inputs)
	if (locale === "ja") return ja_receipt_is_still_generating_t(inputs)
	if (locale === "zh") return zh_receipt_is_still_generating_t(inputs)
	if (locale === "ar") return ar_receipt_is_still_generating_t(inputs)
	if (locale === "id") return id_receipt_is_still_generating_t(inputs)
	if (locale === "it") return it_receipt_is_still_generating_t(inputs)
	if (locale === "ru") return ru_receipt_is_still_generating_t(inputs)
	if (locale === "pt") return pt_receipt_is_still_generating_t(inputs)
	return ko_receipt_is_still_generating_t(inputs)
});